import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { activateTrip, cancelTrip } from '../../Services/ApiCallsServices/PaymentApi';
import { decryptData } from '../../utils/encryption';
import logo from '../../logos/storage-sprint.png';

const useTripInfo = () => {
  const [tripInfo, setTripInfo] = useState(null);

  useEffect(() => {
    const storedTripInfo = decryptData('qwertyuiop');
    if (storedTripInfo) {
      try {
        setTripInfo(JSON.parse(storedTripInfo));
      } catch (error) {
        console.error("Error parsing tripInfo from localStorage:", error);
        setTripInfo(null);
      }
    }
  }, []);

  return tripInfo;
};

const RedirectMessage = ({ icon, title, message, redirectDelay = 5000 }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard/');
    }, redirectDelay);

    return () => clearTimeout(timer);
  }, [navigate, redirectDelay]);

  return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
        <Helmet>
          <title>{title} | Storage Sprint</title>
        </Helmet>

        <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 text-center">
          <img
              src={logo}
              alt="Storage Sprint Logo"
              className="mx-auto mb-6 w-20 h-auto"
          />

          <div className="flex justify-center mb-6 text-yellow-500 text-6xl">
            {icon}
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-4">{title}</h2>
          <p className="text-gray-600 mb-4">{message}</p>
          <p className="text-gray-500 italic mb-6">
            You will be redirected to the dashboard shortly...
          </p>

          <button
              onClick={() => navigate('/dashboard/')}
              className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded-lg transition"
          >
            Go Back Home Now
          </button>
        </div>
      </div>
  );
};

export const Success = () => {
  const tripInfo = useTripInfo();

  useEffect(() => {
    const runActivation = async () => {
      if (!tripInfo) {
        console.error('No trip info found in localStorage');
        return;
      }

      try {
        await activateTrip(tripInfo.reference);
        localStorage.removeItem('qwertyuiop');
      } catch (error) {
        console.error('Failed to activate trip:', error);
      }
    };

    runActivation();
  }, [tripInfo]);

  return (
      <RedirectMessage
          icon={<FaCheckCircle />}
          title="Payment Successful"
          message="Your payment was completed successfully. Thank you for your order!"
      />
  );
};

export const Cancel = () => {
  const tripInfo = useTripInfo();

  useEffect(() => {
    const runCancellation = async () => {
      if (!tripInfo) {
        console.error('No trip info found in localStorage');
        return;
      }

      try {
        await cancelTrip(tripInfo.reference);
        localStorage.removeItem('qwertyuiop');
      } catch (error) {
        console.error('Failed to cancel trip:', error);
      }
    };

    runCancellation();
  }, [tripInfo]);

  return (
      <RedirectMessage
          icon={<FaTimesCircle />}
          title="Payment Canceled"
          message="Your payment has been canceled. Please try again or contact support."
      />
  );
};
